import { ModuleProps, CreateModuleProps } from "components";
import { Routes } from "./Routes";

export const Module: ModuleProps = CreateModuleProps({
    id: "PUBLIC_INVOICE_ESTIMATOR",
    applicationRights: [],
    title: '',
    text: '',
    icon: '',
    hasMenuItem: false,
    canShowOnDashboard: false,
    showOnDashboardByDefault: false,
    routes: Routes
})
